<template>
  <!-- 对话框 -->
  <el-drawer
    title="修改模式类型"
    :visible.sync="show"
    :before-close="closeDialog"
    :with-header="false"
    size="70%"
  >
    <div style="display: flex; justify-content:flex-end;padding: 20px 20px 0;">

      <el-button
        @click="addContent"
        type="success"
        style="width: 50px; height: 40px;"
        icon="el-icon-plus"
      ></el-button>

    </div>
    <!-- 基本信息表单 -->
    <div
            class="form-box"
            style=" height: 80vh; overflow-y: auto; margin-top: 20px;"
    >
      <el-form label-width="80px">

        <el-form-item
                label="模式名称"
                label-width="180px"
        >

          <el-input
                  v-model="submit_data.name"
                  style="width: 150px;"
                  :placeholder="submit_rules.name.placeholder"
          >
          </el-input>

        </el-form-item>



        <div
                v-for="(item, index) in spare_data"
                :key="index"
                class="box-content"
        >

          <div style="display: flex; justify-content: flex-end;">
            <el-button
                    type="danger"
                    @click="delData(index)"
                    icon="el-icon-close"
            ></el-button>
          </div>

          <!-- 选择时间 -->
          <div class="box-time">

            <el-form-item
                    :label="obtain_data.time_start.name"
                    label-width="180px"
            >
              <el-time-picker
                      v-model="spare_data[index].time_start"
                      :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                      placeholder="开始时间"
                      @change="timeChange($event,'time_start')"
                      value-format="HHmm"
                      format="HH:mm"
                      style="width: 150px;"
              >
              </el-time-picker>
            </el-form-item>

            <el-form-item
                    :label="obtain_data.time_end.name"
                    label-width="180px"
            >
              <el-time-picker
                      v-model="spare_data[index].time_end"
                      :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                      placeholder="结束时间"
                      @change="timeChange($event,'time_end')"
                      value-format="HHmm"
                      format="HH:mm"
              >
              </el-time-picker>
            </el-form-item>

          </div>



          <div class="box-body">
            <el-form-item
                    :label="item2.name"
                    label-width="180px"
                    v-for="(item2, index2) in obtain_data"
                    :key="index2"
                    v-show="item2.type!='string' && item2.type!='select'"
            >

              <el-input v-model="spare_data[index][index2]">
              </el-input>

            </el-form-item>

            <el-form-item></el-form-item>
          </div>

        </div>

      </el-form>

    </div>
    <div style="display: flex; justify-content: center;margin-top:10px">
      <el-button
        type="primary"
        @click="drivingModelOnSubmit"
        style="width: 200px; height: 40px;"
      >保存</el-button>
    </div>

  </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            // 获取模式规则
            _this
                .$post('/legwork/getLegWorkRuleMode')
                .then((res) => {
                    _this.obtain_data = res.data;
                })
                .catch((err) => {});
        }
    },
    data() {
        return {
            show: false,

            // 合作模式开关
            partner_value: false,

            password_btn: false,

            // 自创单模式开关
            wait_value: false,

            // 下拉搜索城市
            value_city_code: '',
            options_city_code: [],
            city_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },

            init_time: '',

            // 下拉选择端口
            value_port: '',

            // 下拉选择管理状态
            value_status: '',

            // 表单数据
            submit_data: {
                city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                name: '',
                synchronization: ''
            },
            submit_rules: {
                city_code: {
                    placeholder: '城市编码',
                    rules: {
                        required: true,
                        message: '城市编码错误',
                        regulation: 'special',
                        rulesData: 'city_code'
                    }
                },
                name: {
                    placeholder: '请输入模式名称',
                    rules: {
                        required: true,
                        message: '模式名称错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },

                synchronization: {
                    placeholder: '收费综合指数',
                    rules: {
                        required: true,
                        message: '收费综合指数错误',
                        regulation: 'synthesize',
                        rulesData: ''
                    }
                }
            },

            //获取到的数据
            obtain_data: [],

            // json格式数据
            spare_data: []
        };
    },
    created() {
        _this = this;
    },
    methods: {


        // 删除按钮
        delData(index) {
            // 删除数组中对应index的数据
            _this.spare_data.splice(index, 1);
        },

        // 提交按钮
        drivingModelOnSubmit() {
            // 判断第一个开始时间和最后一个结束时间是否一致
            if (_this.spare_data[0].time_start != _this.spare_data[_this.spare_data.length - 1].time_end) {
                _this.$message.error('时间未形成闭环');
                return;
            }

            for (let i = 1; i < _this.spare_data.length; i++) {
                // 判断开始时间和上一个结束时间是否一致
                if (_this.spare_data[i].time_start != _this.spare_data[i - 1].time_end) {
                    _this.$message.error('时间填写有误，必须包含一天所有时间段');
                    return;
                }
            }

            _this.submit_rules.synchronization.rulesData = _this.obtain_data;

            // 将json格式数据转换成字符串格式赋值给要提交的对象
            _this.submit_data.synchronization = JSON.stringify(_this.spare_data);

          console.log(_this.submit_data);
            _this
                .$post(
                    '/legwork/addOrderLegWorkModeSubmit',
                    _this.submit_data
                )
                .then((res) => {
                    _this.$message.success('添加' + res.msg);
                    // 向父组件通讯刷新表格内容
                    _this.$emit('onSubmit');
                    // 关闭对话框
                    _this.closeDialog();
                })
                .catch((err) => {});
        },


        //添加按钮
        addContent() {
            var obj = {};

            // 遍历获取到的数据，将对象的键存到obj对象中(值为空)
            for (const key in _this.obtain_data) {
                obj[key] = '';
            }
            obj['time_start'] = _this.init_time;
            // 每点击一次在数组中加入一个对象
            _this.spare_data.push(obj);
        },

        timeChange(val, keyData) {
            if (keyData == 'time_end') {
                _this.init_time = val;
            }
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.spare_data = [];

            _this.submit_data = {
                city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                name: '',
                synchronization: '',
            };

            _this.init_time = '';
        },


    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.box-content {
    background-color: #eee;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
}

.box-time {
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 20px 0;
}

.box-body {
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 20px 0;
    flex-wrap: wrap;
}

.box-time .el-form-item {
    width: 40%;
}

.box-time .el-form-item .el-date-editor {
    width: 150px;
}

.el-form-item {
    width: 40%;
}

.form-box .el-form {
    display: flex;
    flex-wrap: wrap;
}

.el-switch {
    width: 100%;
    /* padding-left: 180px;
    box-sizing: border-box; */
}
</style>